import type { ReactNode } from "react";

import { Logo } from "../app/shell/Logo";

export const LEMA_MARCA = "Más control para un campo productivo.";

/**
 * Marco de las pantallas públicas (login, registro, onboarding): logo del kit sobre fondo claro
 * y lema de marca (guía §6.2).
 */
export function LayoutAuth({ children, ancho = "max-w-md", lema = LEMA_MARCA }: { children: ReactNode; ancho?: string; lema?: string }) {
  return (
    <main className="grid min-h-dvh place-items-center bg-fondo p-4">
      <section className={`w-full ${ancho} rounded-modal border border-borde/60 bg-superficie p-6 shadow-suave`}>
        <header className="mb-6">
          <Logo variante="horizontal" fondo="claro" />
          <p className="mt-3 text-nota text-texto-suave">{lema}</p>
        </header>
        {children}
      </section>
    </main>
  );
}
